import { Controller } from '@hotwired/stimulus';
import { CHROMIUM_BROWSER_NAMES, chromiumBrowserBrand } from './helpers/browser_brand';

// Connects to data-controller="browser"
export default class extends Controller {
  CHROMIUM_ENGINE = 'Chromium';

  chromiumBrowserNames = CHROMIUM_BROWSER_NAMES;
  static values = { browserEngine: String };
  static targets = ['browserName', 'browserIcon', 'browserButton'];

  connect() {
    const browserName = this.getBrowserName();
    this.browserNameTarget.textContent = browserName;
    this.browserIconTarget.classList.add(this.getBrowserIcon());
    this.element.dataset.browserResolved = '';
  }

  getBrowserName() {
    // Return the engine for non-Chromium browsers, or when the brand can't be resolved
    if (!this.__isChromium()) return this.browserEngineValue;
    return chromiumBrowserBrand() || this.browserEngineValue;
  }

  getBrowserIcon() {
    const browserName = this.getBrowserName();

    if (browserName == 'Microsoft Edge') {
      return 'bi-browser-edge';
    }
    if (this.chromiumBrowserNames.includes(browserName)) {
      return 'bi-browser-chrome';
    }

    switch (browserName) {
      case 'Firefox':
        return 'bi-browser-firefox';
      case 'Safari':
        return 'bi-browser-safari';
      default:
        return 'bi-question-circle';
    }
  }

  private;

  __isChromium() {
    return this.browserEngineValue == this.CHROMIUM_ENGINE;
  }
}
